module.exports = __webpack_public_path__ + "static/media/avatar.86c04d9f.svg";